export class CountUpAnimation {
	#start = {};

	constructor(duration = 2000, easing = 'ease-out') {
		this.duration = duration;
		this.easing = easing;
		this.#start = {};
	}

	startAnimation(element) {
		const from = parseFloat(element.dataset.from);
		const to = parseFloat(element.dataset.to);
		const prefix = element.dataset.prefix || '';
		const suffix = element.dataset.suffix || '';

		// element.removeAttribute('data-from');
		// element.removeAttribute('data-to');
		// element.removeAttribute('data-prefix');
		// element.removeAttribute('data-suffix');
		this.#animate(element, from, to, prefix, suffix);
	}

	#animate(element, from, to, prefix, suffix) {
		const startTime = performance.now();

		const step = (currentTime) => {
			if (!this.#start[element]) this.#start[element] = currentTime;
			const progress = Math.min((currentTime - this.#start[element]) / this.duration, 1);
			const easeProgress = this.#ease(progress);
			const currentValue = from + (to - from) * easeProgress;
			element.innerHTML = prefix + new Intl.NumberFormat().format(currentValue.toFixed(0)) + suffix;

			if (progress < 1) {
				requestAnimationFrame(step);
			}
		};

		requestAnimationFrame(step);
	}

	#ease(progress) {
		switch (this.easing) {
			case 'ease-in':
				return progress * progress;
			case 'ease-out':
				return progress * (2 - progress);
			case 'ease-in-out':
				return progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
			default:
				return progress;
		}
	}
}
